import {
  selectCurrentLanguage,
  selectLocalizedLanguages,
  updateLocalizedRecord,
} from "../../../app/slices/TrainingLocalizationSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectTrainingLocalizationState } from "../../../app/slices/TrainingLocalizationSlice";

export const useWordSpinnerLocalizationHelper = () => {
  const dispatch = useDispatch();
  const locState = useSelector(selectTrainingLocalizationState);
  const currLang = useSelector(selectCurrentLanguage);
  const localizedLanguages = useSelector(selectLocalizedLanguages);

  const removeBracketsFromAllLanguages = (
    key: string,
    correctAnswerKey: string | undefined
  ) => {
    if (correctAnswerKey === undefined) return;

    const entries = localizedLanguages.map((lang) =>
      getEntry(key, lang.shortcode, correctAnswerKey)
    );

    dispatch(updateLocalizedRecord({ key, entries }));
  };

  const getEntry = (
    key: string,
    lang: string,
    correctAnswerKey: string
  ): { shortcode: string; value: string } => {
    const tempRecord = locState.localizedEntries[key][lang];
    const tempCorrectAnswer = locState.localizedEntries[correctAnswerKey][lang];

    return {
      shortcode: lang,
      value: tempRecord.value.replace("{0}", tempCorrectAnswer.value),
    };
  };

  return { removeBracketsFromAllLanguages, getEntry } as const;
};
